module.exports = __webpack_public_path__ + "img/ali-logo.89503287.png";